import React from 'react'
import { Link } from 'react-router-dom'

export default function PageHeader({ badge, title, subtitle, breadcrumb = [] }) {
  return (
    <section className="bg-gradient-to-b from-[#0c304d] via-[#0e3759] to-[#0c304d] text-white py-14 sm:py-18 relative overflow-hidden">
      {/* Subtile baggrundsformer til varme og dybde */}
      <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-[#f39223]/10 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-24 -left-24 w-80 h-80 rounded-full bg-sky-500/10 blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Brødkrummer */}
        <nav aria-label="Brødkrummer" className="flex items-center gap-2 text-xs sm:text-sm text-neutral-300 mb-6">
          <Link to="/" className="hover:text-[#f39223] transition-colors flex items-center gap-1.5">
            <i className="fa-solid fa-house text-xs" aria-hidden="true" />
            <span>Forside</span>
          </Link>
          {breadcrumb.map((crumb, idx) => (
            <span key={idx} className="inline-flex items-center gap-2">
              <i className="fa-solid fa-chevron-right text-[10px] text-neutral-400" aria-hidden="true" />
              {crumb.to ? (
                <Link to={crumb.to} className="hover:text-[#f39223] transition-colors">
                  {crumb.label}
                </Link>
              ) : (
                <span className="text-white font-medium">{crumb.label}</span>
              )}
            </span>
          ))}
        </nav>

        <div className="max-w-3xl">
          {badge && (
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-[#f39223] text-white uppercase tracking-wider mb-4 shadow-xs">
              <i className="fa-solid fa-heart text-[10px]" aria-hidden="true" />
              {badge}
            </span>
          )}
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white tracking-tight leading-tight">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-4 text-base sm:text-lg text-neutral-200 leading-relaxed max-w-2xl font-normal">
              {subtitle}
            </p>
          )}
        </div>
      </div>
    </section>
  )
}
